'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _validate2 = require('validate.js');

var _validate3 = _interopRequireDefault(_validate2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logOn = false;
var debugLog = logOn ? console.log : function () {
	return undefined;
}; // eslint-disable-line no-console

var Field = function (_Component) {
	(0, _inherits3.default)(Field, _Component);

	function Field(props) {
		(0, _classCallCheck3.default)(this, Field);

		var _this = (0, _possibleConstructorReturn3.default)(this, (Field.__proto__ || (0, _getPrototypeOf2.default)(Field)).call(this, props));

		_this.state = {
			hasBlurred: false,
			attribs: {
				// Apply bindings, passing in existing events, so they also get called.
				onChange: _this.handleOnChange.bind(_this, props.onChange, props.getComponentValue),
				onBlur: _this.handleOnBlur.bind(_this, props.onBlur)
			}
		};

		_this.debug = _this.debug.bind(_this);
		_this.getValue = _this.getValue.bind(_this);
		_this.isDebug = _this.isDebug.bind(_this);
		_this.validate = _this.validate.bind(_this);
		_this.isMountedComponent = false;
		return _this;
	}

	(0, _createClass3.default)(Field, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.context.store.setFieldRef(this);
			this.isMountedComponent = true;

			this.debug({ fieldCreated: {
					props: this.props
				} });
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			var shouldUpdate = this.previousValue !== this.getValue();
			this.previousValue = this.getValue();
			return shouldUpdate || this.props.value !== nextProps.value || this.state.attribs.error !== nextState.attribs.error;
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.context.store.deleteFieldRef(this);
			this.isMountedComponent = false;

			this.debug({ fieldRemoved: {
					props: this.props
				} });
		}
	}, {
		key: 'getValue',
		value: function getValue(constraints) {
			var value = this.context.store && this.context.store.get && this.context.store.get(this.props.name, undefined, !!(constraints && constraints.allowEmpty));
			if (this.props.arrayIndex !== undefined) {
				value = value[this.props.arrayIndex];
			}
			return value;
		}

		//	For numbers we need value to be passed back as undefined, and it works with other validations as well.
		//	If you want to always get an undefined value (Note: numeric values break on empty!), add allowEmpty in your validation

	}, {
		key: 'getValueForValidation',
		value: function getValueForValidation(constraints) {
			var value = this.getValue();
			if (!(constraints && constraints.allowEmpty) && value === '') {
				value = undefined;
			}
			return value;
		}
	}, {
		key: 'isDebug',
		value: function isDebug() {
			return this.props.debug === undefined && this.context.debug || this.props.debug;
		}
	}, {
		key: 'debug',
		value: function debug(obj) {
			if (this.isDebug()) {
				console.log('Formality field ' + this.props.name + (this.props.arrayIndex !== undefined ? '[' + this.props.arrayIndex + ']' : ''), obj); // eslint-disable-line no-console
			}
		}
	}, {
		key: 'validate',
		value: function () {
			var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				var setValidation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
				var obj, constraints, name, value, validationErrors, error, helperText, errorAttribs;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								//	Validates the field
								obj = {};
								constraints = {};
								name = this.props.name;
								value = this.getValueForValidation(this.props.validate);


								obj[name] = value;
								constraints[name] = this.props.validate;
								validationErrors = void 0;
								_context.prev = 7;
								_context.next = 10;
								return _validate3.default.async(obj, constraints);

							case 10:
								_context.next = 16;
								break;

							case 12:
								_context.prev = 12;
								_context.t0 = _context['catch'](7);

								validationErrors = _context.t0 instanceof Error ? ['Unknown error'] : _context.t0[name];

								this.debug({ validateFieldError: {
										exception: _context.t0
									} });

							case 16:

								// during form submit, we can let the form set all the validations at the end
								if (setValidation) {
									this.context.store.setValidation(name, validationErrors);
								}

								error = validationErrors && validationErrors.length > 0;
								helperText = error ? validationErrors.join(', ') : null;
								errorAttribs = this.props.supportsHelperText ? { error: error, helperText: helperText } : { error: error };

								debugLog('SET STATE validate', this.props.name, this.props.arrayIndex, errorAttribs);
								if (this.isMountedComponent) {
									this.setState({ attribs: (0, _extends3.default)({}, this.state.attribs, errorAttribs) });
								}

								this.debug({ validateField: (0, _extends3.default)({
										value: value,
										validate: this.props.validate,
										isValid: !validationErrors,
										validationResult: validationErrors
									}, errorAttribs) });

								return _context.abrupt('return', validationErrors);

							case 24:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this, [[7, 12]]);
			}));

			function validate() {
				return _ref.apply(this, arguments);
			}

			return validate;
		}()
	}, {
		key: 'handleOnChange',
		value: function () {
			var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(oldHandler, getComponentValue) {
				for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
					args[_key - 2] = arguments[_key];
				}

				var event, index, setValue, name, value;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								event = args[0], index = args[1], setValue = args[2];
								//	When the field's onChange event fires, we update the state value

								name = this.props.name;
								value = void 0;

								//	Ability to use custom handler for getting the value

								if (getComponentValue) {
									value = getComponentValue.apply(this, args);
								} else {
									//	Get the value from the event - or the `setValue`, or `index`, if no
									//	setValue. This caters for components that don't always return the
									//	value in the event, such as material-ui. The `index` and `setValue`
									//	is for indexed components, such a a dropdown menu, but of course
									//	works with standard components that return the value in the `index`
									//	variable.
									// eslint-disable-next-line no-nested-ternary
									value = event && event.target && event.target.value !== undefined ? event.target.value : setValue !== undefined ? setValue : index;
								}

								this.context.store.set(name, value, this.props.arrayIndex);

								//	Validate, as long as the field has been blurred at least once

								if (!(this.props.validate && (this.props.forcevalidate || this.state.hasBlurred))) {
									_context2.next = 8;
									break;
								}

								_context2.next = 8;
								return this.validate();

							case 8:

								if (oldHandler) {
									oldHandler.apply(this, args);
								}

								this.debug({ handleOnChange: {
										value: value,
										store: this.context.store,
										validated: this.props.validate && this.state.hasBlurred,
										hasOldHandler: !!oldHandler
									} });

							case 10:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function handleOnChange(_x2, _x3) {
				return _ref2.apply(this, arguments);
			}

			return handleOnChange;
		}()
	}, {
		key: 'handleOnBlur',
		value: function () {
			var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(oldHandler) {
				var _len2,
				    args,
				    _key2,
				    _args3 = arguments;

				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								//	When the field is blurred - we use this to see if we should validate
								//	TODO: need a way to do this on non-blurrable nodes, such as the RadioButtonGroup example...
								debugLog('SET STATE handleOnBlur', this.props.name, this.props.arrayIndex);
								if (this.isMountedComponent) {
									this.setState({ hasBlurred: true });
								}

								if (!this.props.validate) {
									_context3.next = 5;
									break;
								}

								_context3.next = 5;
								return this.validate();

							case 5:

								if (oldHandler) {
									for (_len2 = _args3.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
										args[_key2 - 1] = _args3[_key2];
									}

									oldHandler.apply(this, args);
								}

								this.debug({ handleOnBlur: {
										state: this.state,
										validated: this.props.validate,
										hasOldHandler: !!oldHandler
									} });

							case 7:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, this);
			}));

			function handleOnBlur(_x4) {
				return _ref3.apply(this, arguments);
			}

			return handleOnBlur;
		}()
	}, {
		key: 'render',
		value: function render() {
			if (!this.context.store) {
				throw new Error('You must have an enclosing form with a store to use this field component');
			}

			//	Grab the props - override with the state, so we can set the helperText, etc...
			var attribs = (0, _extends3.default)({}, this.props, this.state.attribs);

			if (!this.props.skipAutosetValue && this.props.value === undefined) {
				attribs.value = this.getValue(this.props.validate);
			}

			//	Remove things React doesn't know about
			delete attribs.component;
			delete attribs.arrayIndex;
			delete attribs.store;
			delete attribs.getComponentValue;
			delete attribs.validate;
			delete attribs.forcevalidate;
			delete attribs.skipAutosetValue;
			delete attribs.debug;
			delete attribs.supportsHelperText;

			var myComponent = _react2.default.createElement(this.props.component, attribs, this.props.children);

			return myComponent;
		}
	}]);
	return Field;
}(_react.Component);

Field.contextTypes = {
	store: _propTypes2.default.object,
	debug: _propTypes2.default.bool
};

Field.propTypes = {
	supportsHelperText: _propTypes2.default.bool,
	debug: _propTypes2.default.bool,
	name: _propTypes2.default.string.isRequired,
	arrayIndex: _propTypes2.default.number,
	validate: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
	onChange: _propTypes2.default.func,
	getComponentValue: _propTypes2.default.func,
	onBlur: _propTypes2.default.func,
	component: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
	value: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types, the type is up to the wrapped component
	skipAutosetValue: _propTypes2.default.bool,
	children: _propTypes2.default.any // eslint-disable-line react/forbid-prop-types
};

Field.defaultProps = {
	supportsHelperText: true,
	debug: undefined,
	arrayIndex: undefined,
	validate: undefined,
	onChange: undefined,
	getComponentValue: undefined,
	onBlur: undefined,
	value: undefined,
	skipAutosetValue: false,
	children: undefined
};

var _default = Field;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(logOn, 'logOn', 'src/field.js');

	__REACT_HOT_LOADER__.register(debugLog, 'debugLog', 'src/field.js');

	__REACT_HOT_LOADER__.register(Field, 'Field', 'src/field.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/field.js');
}();

;


// WEBPACK FOOTER //
// /Users/david/Source/react-formality/lib/field.js